// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"363":"bb4faeedb4de7344","837":"1d30f46287d435be"}[chunkId] + ".js";
};